export enum StatusFilterEnum {
  MANAGEMENT_STATUS_LIST = 'managementStatusList', //multi-select form control (string[]: ['AUTOMATICALLY_MANAGED', 'MANUALLY_MANAGED', 'NOT_MANAGED']
  BUSINESS_STATUS_LIST = 'businessStatusList', //multi-select form control (string[]: ['PERMANENTLY_CLOSED', 'TEMPORARILY_CLOSED', 'OPEN']
  IS_FOUND_IN_MY_BUSINESS = 'isFoundInMyBusiness', //single-select form control (boolean: true/false/null)
  IS_NOT_FOUND_IN_MY_BUSINESS = 'isNotFoundInMyBusiness',
  IS_DIFFERENT_IN_MY_BUSINESS = 'isDifferentInMyBusiness', //single-select form control (boolean: true/false/null)
  IS_NOT_DIFFERENT_IN_MY_BUSINESS = 'isNotDifferentInMyBusiness',
  HAS_IGNORED_DIFFERENCES = 'hasIgnoredDifferences', //single-select form control (boolean: true/false/null)
  HAS_NO_IGNORED_DIFFERENCES = 'hasNoIgnoredDifferences',
  HAS_BLACKLISTED_FIELDS = 'hasBlacklistedFields', //single-select form control (boolean: true/false/null)
  HAS_NO_BLACKLISTED_FIELDS = 'hasNoBlacklistedFields',
  IS_VERIFIED = 'isVerified', //single-select form control (boolean: true/false/null)
  IS_NOT_VERIFIED = 'isNotVerified',
  HAS_UPDATE_ERROR = 'hasUpdateError', //single-select form control (boolean: true/false/null),
  HAS_NO_UPDATE_ERROR = 'hasNoUpdateError',
  HAS_IMPORT_ERROR = 'hasImportError', //single-select form control(boolean: true/false/null)
  HAS_NO_IMPORT_ERROR = 'hasNoImportError',
  HAS_COMPLETED_CC = 'hasCompletedClaimAndClean', // single-select form control (boolean: true/false/null)
  HAS_NOT_COMPLETED_CC = 'hasNotCompletedClaimAndClean',
}
